<template>
  <Layout>
    <div v-if="selectedIncident.id">
      <div class="row">
        <div>
          <div class="card">
            <div class="card-body row">
              <h4 class="card-title">
                <div class="row">
                  <div class="col-6">
                    <button type="button" onclick="history.back()" class="btn btn-sm btn-outline-primary mr-3">
                      <i class="bx bx-chevron-left"></i>
                    </button>
                  </div>
                  <div class="col-6">
                    <div class="float-end">
                      <button :class="`btn btn-sm m-2 ${statusColor}`">
                        Status: {{ selectedIncident.status }}
                      </button>
                    </div>
                  </div>
                </div>
              </h4>
              <hr />
              <div class="table-responsive col-6">
                <table class="table mb-0">
                  <tbody>
                    <tr>
                      <th scope="row">Incident Id</th>
                      <td>{{ selectedIncident.id }}</td>
                    </tr>

                    <tr>
                      <th scope="row">Source</th>
                      <td>{{ sourceName }}
                      </td>
                    </tr>

                    <tr>
                      <th scope="row">Chainage Location</th>
                      <td>{{ selectedIncident.ch_no }}
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Challan Status</th>
                      <td>
                        {{ GetChallanFriendlyName(selectedIncident.challan_status) }}
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Incident Date/Time</th>
                      <td>
                        {{
                          getReadableDateTime(selectedIncident.incident_datetime)
                        }}
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Reported Date/Time</th>
                      <td>
                        {{
                          new Date(
                            selectedIncident.reported_datetime
                          ).toLocaleString()
                        }}
                      </td>
                    </tr>

                    <tr v-show="selectedIncident.status !== 'Open'">
                      <th scope="row">Close Date/Time</th>
                      <td>{{ selectedIncident.close_datetime }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="table-responsive col-6">
                <table class="table mb-0">
                  <tbody>
                    <tr>
                      <th scope="row">Assigned To</th>
                      <td>
                        {{ rpoName }} (ID: {{ selectedIncident.reported_to }})
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Sub Category</th>
                      <td>
                        {{
                          subCategoryName
                        }}
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Side</th>
                      <td>
                        {{
                          selectedIncident.side
                        }}
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Description</th>
                      <td>
                        {{
                          selectedIncident.description != null
                          ? selectedIncident.description
                          : "NA"
                        }}
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Vehicle Number</th>
                      <td contenteditable @input="onInput" style="text-transform: uppercase">
                        {{
                          selectedIncident.vehicle_no != null
                          ? selectedIncident.vehicle_no
                          : "NA"
                        }}
                      </td>
                    </tr>

                    <tr>
                      <th scope="row">Vehicle Class</th>
                      <td>
                        {{ vehicleClassName }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Incident Photos details -->
      <div class="row">
        <div class="col-6">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title">
                {{ selectedIncident.category_name }} Photos
              </h4>
              <hr />
              <div class="text-center" v-if="incidentImages.length === 0">
                <p>No images added</p>
              </div>

              <div v-else>
                <img v-for="(src, index) in incidentImages" :key="index" class="float-left image mb-2"
                  @click="() => showCaptiomImg(index)" width="150" :src="src"
                  style="margin-right: 10px; cursor: pointer" />
              </div>
            </div>
            <vue-easy-lightbox :visible="visibleCaption" :imgs="incidentImages" :index="index"
              @hide="handleCaptionHide"></vue-easy-lightbox>
          </div>
        </div>
        <div class="col-6">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title">Vehicle Journey</h4>
              <hr />
              <SectionSpeed></SectionSpeed>
            </div>
          </div>
        </div>
      </div>

      <!-- Select RPO modal -->
      <b-modal id="select-rpo-modal" size="md" hide-footer>
        <template #modal-header>
          <div>
            <h5>Select RPO</h5>
          </div>
          <div class="m-2">
            <button class="btn btn-sm btn-success" @click="informedToRpo()">
              Select
            </button>
            <button class="btn btn-sm btn-outline-danger m-2" @click="$bvModal.hide('select-rpo-modal')">
              Cancel
            </button>
          </div>
        </template>
        <div>
          <v-select v-model="selectedIncident.reported_to_name" :options="options.informedTo" label="firstName"
            :reduce="(vc) => vc.firstName"></v-select>
        </div>
      </b-modal>

      <!-- Edit vehicle details -->
      <b-modal id="edit-vehicle-details-modal" title="Edit Vehicle Details" title-class="font-18" hide-footer
        no-close-on-backdrop>
        <template #modal-header>
          <div>
            <h5>Vehicle Details</h5>
          </div>
          <div>
            <button class="btn btn-sm btn-outline-danger" @click="$bvModal.hide('edit-vehicle-details-modal')">
              Cancel
            </button>
          </div>
        </template>

        <div>
          <div class="card">
            <div class="card-body">
              <div class="table-responsive">
                <table class="table mb-0">
                  <tbody>
                    <tr>
                      <th scope="row">Driver Name</th>
                      <td>{{ selectedVehicle.driver_name }}</td>
                    </tr>
                    <tr>
                      <th scope="row">Vehicle No.</th>
                      <td>{{ selectedVehicle.vehicle_no }}</td>
                    </tr>
                    <tr>
                      <th scope="row">Vehicle Class</th>
                      <td>{{ vehicleClass }}</td>
                    </tr>
                    <tr>
                      <th scope="row">Mobile No.</th>
                      <td>{{ selectedVehicle.mobile_no }}</td>
                    </tr>
                    <tr>
                      <th scope="row">Driver Address</th>
                      <td>{{ selectedVehicle.driver_address }}</td>
                    </tr>
                    <tr>
                      <th scope="row">Origin of Vehicle</th>
                      <td>{{ selectedVehicle.origin }}</td>
                    </tr>
                    <tr>
                      <th scope="row">Point of Arrival</th>
                      <td>{{ selectedVehicle.arrival }}</td>
                    </tr>
                    <tr>
                      <th scope="row">Destination of Vehicle</th>
                      <td>{{ selectedVehicle.destination }}</td>
                    </tr>
                    <tr>
                      <th scope="row">No. of Passengers</th>
                      <td>
                        {{ selectedVehicle.passenger_count }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </b-modal>
    </div>
    <div v-else>
      <widgetLoader></widgetLoader>
    </div>
  </Layout>
</template>

<script>
import Layout from "@/layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Swal from "sweetalert2";
import incidentMixin from "../../mixins/incident";
import VueEasyLightbox from "vue-easy-lightbox";
import SectionSpeed from "@/components/incidents/section-speed";
import widgetLoader from "@/components/widgets/widget-loader";
/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Incident Details",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },

  mixins: [incidentMixin],
  props: {
    incidentId: String,
  },

  components: {
    Layout,
    PageHeader,
    VueEasyLightbox,
    SectionSpeed,
    widgetLoader
  },

  data () {
    return {
      selectedIncident: {},
      visibleCaption: false,
      index: 1,
      vehicleNumber: null,
      items: [],
      selectedVehicle: {},
      vehicleClass: null,

      options: {
        vehicleClass: [],
        offenceId: [],
        districtCode: [],
        stateCode: [],
        dpCd: [{ name: "TD" }, { name: "TR" }],
        violationSrc: [{ name: "SLV" }, { name: "RLV" }],
        subCategory: [],
        informedTo: [],
      },
      fields: [
        {
          key: "driver_name",
          label: "Driver Name",
          sortable: true,
        },
        {
          key: "vehicle_no",
          label: "Vehicle No.",
          sortable: false,
        },
        {
          key: "mobile_no",
          label: "Mobile No.",
          sortable: false,
        },
        {
          key: "passenger_count",
          label: "No. of Passengers",
          sortable: false,
        },
        {
          key: "driver_address",
          label: "Driver Address",
          sortable: false,
        },
        {
          key: "actions",
        },
      ],
    };
  },

  methods: {
    async onInput (e) {
      this.vehicleNumber = await e.target.innerText;
    },

    sendNotificationToRPO () {
      this.$bvModal.show("select-rpo-modal");
    },

    informedToRpo () {
      Swal.fire(
        "RPO Selected!",
        "RPO has been selected and notifications have been sent.",
        "success"
      ).then(() => {
        this.$bvModal.hide("select-rpo-modal");
      });
    },

    async getIncidentMasters () {
      try {
        const incidents = await this.GetIncidentMasters();
        this.options.vehicleClass = incidents.getVehicleClass;
        this.options.offenceId = incidents.getOffenceId;
        this.options.districtCode = incidents.getDistrictCode;
        this.options.stateCode = incidents.getStateCode;
        this.options.subCategory = incidents.getIncidentSubCategory;
        this.options.informedTo = incidents.rpoData;
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
        Swal.fire(
          "Network Error",
          "Failed to fetch data from the server. Please check your internet connection.",
          "error"
        );
      }
    },

    async showVehicles (id) {
      const body = {
        id: id,
      };
      this.items = await this.ShowVehicleDetails(body);
    },

    editVehicleDetails (vehicle) {
      this.selectedVehicle = vehicle;
      if (this.selectedVehicle.vehicle_class_id) {
        const vehicleClass = this.options.vehicleClass.find(
          (vehicleClass) =>
            vehicleClass.id === this.selectedVehicle.vehicle_class_id
        );
        this.vehicleClass = vehicleClass.class_name;
      }
      this.$bvModal.show("edit-vehicle-details-modal");
    },

    showCaptiomImg (index) {
      this.index = index;
      this.visibleCaption = true;
    },

    handleCaptionHide () {
      this.visibleCaption = false;
    },

    getReadableDateTime (dateTime) {
      if (dateTime) {
        // const date = String(dateTime).split("T");
        return `${new Date(dateTime).toLocaleString()}`;
      }
    },

    challanGenerated () {
      Swal.fire(
        "Challan Generated",
        "Challan has been raised to this incident",
        "success"
      )
        .then(() => {
          this.$bvModal.hide("raise-challan-modal");
        })
        .then(() => {
          const btn = document.getElementById(
            `${this.currentChallanModalId - 1}-raise-challan-btn`
          );
          if (btn) {
            this.currentChallanModalId = this.currentChallanModalId - 1;
            btn.click();
          }
        });
    },

    async updateIncidentDetails () {
      const vehicleClass = this.options.vehicleClass.find(
        (vehicleClass) =>
          vehicleClass.class_name === this.selectedIncident.class_name
      );

      let informedToId = null;

      if (this.selectedIncident.reported_to_name) {
        const splitInformedTo =
          this.selectedIncident.reported_to_name.split(" ");
        const firstName = splitInformedTo.shift(0);

        const informedTo = this.options.informedTo.find(
          (name) => name.firstName === firstName
        );
        informedToId = informedTo.id;
      }

      let getVehicleNumber = null;

      if (this.vehicleNumber) {
        getVehicleNumber = this.vehicleNumber;
      } else {
        getVehicleNumber = this.selectedIncident.vehicle_no;
      }

      await this.incidentSaved();
      const body = {
        id: this.selectedIncident.id,
        vehicle_no: getVehicleNumber,
        vehicle_class_id: vehicleClass.id,
        reported_to: informedToId,
      };
      await this.UpdateVehicleNumber(body);
    },

    async convertIncidentToAccident () {
      const body = {
        id: this.selectedIncident.id,
      };

      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, convert it!",
      }).then(async (result) => {
        if (result.isConfirmed) {
          await this.ConvertIncidentToAccident(body);
          Swal.fire(
            "Converted!",
            "This Incident converted into Accident.",
            "success"
          );
        }
      });
    },

    incidentSaved () {
      Swal.fire(
        "Saved",
        "Incident details updated successfully",
        "success"
      ).then(() => {
        this.$bvModal.hide("more-details-modal");
        this.$bvModal.hide("raise-challan-modal");
      });
    },

    async generateChallan () {
      try {
        let images = [];
        for (let image of this.selectedIncident.images) {
          images.push(image.media_url);
        }

        const body = {
          incidentId: this.selectedIncident.id,
          id: "2",
          offenceId: this.offenceId,
          dpCd: this.dpCd,
          latitude: this.selectedIncident.lat,
          transactionNo: this.selectedIncident.transaction_id,
          userId: "1",
          regnNo: this.selectedIncident.vehicle_no,
          voilationSource: this.voilationSource,
          voilationSourceCatg: this.selectedIncident.sub_category_name,
          stateCd: this.stateCd,
          districtId: this.districtId,
          location: this.selectedIncident.location,
          offCd: 55,
          equipmentId: this.selectedIncident.camera_id,
          vendorName: "VEH",
          vehicleSpeed: parseInt(this.vehicleSpeed),
          speedLimit: this.selectedIncident.speed_limit,
          vehicleWeight: 0,
          voilationTime: this.selectedIncident.incident_datetime,
          actionTime: new Date(),
          longitude: this.selectedIncident.long,
          images: images,
        };
        await this.GenerateChallan(body);
        await this.updateIncidentDetails();
        await this.challanGenerated();
        this.$bvModal.hide("more-details-modal");
      } catch (e) {
        console.error(e);
        Swal.fire(
          "Challan Generation Failed",
          e.response.data.message,
          "error"
        );
      }
    },
  },

  computed: {
    masters () {
      return this.$store.getters["incident/masters"];
    },
    incidentImages () {
      return this.selectedIncident.images
        ? this.selectedIncident.images.map((e) => e.media_url)
        : [];
    },
    sourceName () {
      return this.masters.incidentSourceMaster && this.selectedIncident.source_id ? this.masters.incidentSourceMaster.find(s => s.id ==
        this.selectedIncident.source_id).source_name : 'NA'
    },
    subCategoryName () {
      return this.masters.incidentSubCategoryMaster && this.selectedIncident.sub_category_id ? this.masters.incidentSubCategoryMaster.find(s => s.id == this.selectedIncident.sub_category_id).sub_category_name : 'NA'
    },
    vehicleClassName () {
      return this.masters.vehicleClass && this.selectedIncident.vehicle_class_id ? this.masters.vehicleClass.find(s => s.id == this.selectedIncident.vehicle_class_id).class_name : 'NA'
    },
    rpoName () {
      return this.options.informedTo && this.selectedIncident.reported_to ? this.options.informedTo.find((u) => u.userId == this.selectedIncident.reported_to).firstName : 'NA'
    },
    statusColor () {
      switch (this.selectedIncident.status) {
        case 'Resolved':
          return 'btn-outline-success'

        default:
          return 'btn-outline-warning'
      }
    }
  },
  async created () {
    await this.getIncidentMasters()
    this.selectedIncident = await this.GetIncidetForIncidentById(
      this.incidentId
    );
  },
};
</script>
